import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const ConfigurationRoutes: Routes = [
  {
    path: "configuration",
    loadComponent: () =>
      import("./configuration.component").then((m) => m.ConfigurationComponent),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./configuration-form/configuration-form.component").then(
            (m) => m.ConfigurationFormComponent,
          ),
      },
    ],
  },
];
